'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _formatNumber = require('../formatNumber');

var _formatNumber2 = _interopRequireDefault(_formatNumber);

var _md = require('react-icons/md');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var Page = (_class = (_temp2 = _class2 = function (_React$Component) {
  (0, _inherits3.default)(Page, _React$Component);

  function Page() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Page);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Page.__proto__ || Object.getPrototypeOf(Page)).call.apply(_ref, [this].concat(args))), _this), _this.state = { page: 1 }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Page, [{
    key: 'USAFE_componentWillReceiveProps',
    value: function USAFE_componentWillReceiveProps(nextProps) {
      if (nextProps.page !== this.props.page) {
        this.setState({ page: nextProps.page });
      }
    }
  }, {
    key: 'onPageBlur',
    value: function onPageBlur(event) {
      this.props.setPage(Number(event.target.value));
    }
  }, {
    key: 'onKeyPress',
    value: function onKeyPress(event) {
      var code = event.keyCode || event.which;
      if (code === 13) {
        this.props.setPage(Number(event.target.value));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          {
            className: this.props.result.hasPreviousPage ? 'paginated-pagination-page-icon' : 'paginated-pagination-page-icon-disabled',
            onClick: function onClick() {
              return _this2.props.result.hasPreviousPage && _this2.props.setPage(_this2.props.page - 1);
            } },
          _react2.default.createElement(_md.MdChevronLeft, { size: 25 })
        ),
        _react2.default.createElement(
          'div',
          { className: 'paginated-pagination-page-input-container' },
          'page',
          ' ',
          _react2.default.createElement('input', {
            name: 'pageInput',
            value: this.state.page,
            onChange: function onChange(event) {
              return _this2.setState({ page: event.target.value });
            },
            onKeyPress: this.onKeyPress,
            onBlur: this.onPageBlur,
            className: 'paginated-pagination-page-input'
          }),
          ' ',
          'of ',
          (0, _formatNumber2.default)(this.props.result.totalPages)
        ),
        _react2.default.createElement(
          'div',
          {
            className: this.props.result.hasNextPage ? 'paginated-pagination-page-icon' : 'paginated-pagination-page-icon-disabled',
            onClick: function onClick() {
              return _this2.props.result.hasNextPage && _this2.props.setPage(_this2.props.page + 1);
            } },
          _react2.default.createElement(_md.MdChevronRight, { size: 25 })
        )
      );
    }
  }]);
  return Page;
}(_react2.default.Component), _class2.propTypes = {
  page: _propTypes2.default.number,
  setPage: _propTypes2.default.func,
  result: _propTypes2.default.object
}, _temp2), (_applyDecoratedDescriptor(_class.prototype, 'onPageBlur', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'onPageBlur'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onKeyPress', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'onKeyPress'), _class.prototype)), _class);
exports.default = Page;